import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
const subCode = {
    "1037": "Artificial Intelligence and Data Science",
    "1024": "Artificial Intelligence and Machine Learning",
    "1010": "Civil Engineering",
    "1011": "Computer Science and Engineering",
    "1016": "Electrical Engineering",
    "1013": "Electronics and Communication Engineering",
    "1014": "Industrial Internet of Things",
    "1015": "Information Technology",
    "1036": "Mathematics and Computing",
    "1035": "Mechanical Engineering",
    "1038": "Microelectronics and VLSI Engineering",
    "1026": "Production and Industrial Engineering",
    "1039": "Robotics and Automation",
    "1040": "Sustainable Energy Technologies"
}
const type = {
    "updates": "Updates",
    "tt": "Time Table",
    "examdates": "Exam Dates",
    "result": "Result",
}
const semester = {
    "1": "1st Semester",
    "2": "2nd Semester",
    "3": "3rd Semester",
    "4": "4th Semester",
    "5": "5th Semester",
    "6": "6th Semester",
    "7": "7th Semester",
    "8": "8th Semester"
}

export default function HomeUpdates() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    useEffect(() => {
        const fetchItems = async () => {
            if (loading || !hasMore) return;
            setLoading(true);
            try {
                const response = await axios.post(process.env.REACT_APP_API_URL + '/updates/items', { page, limit: 10 }, { withCredentials: true });
                setData((prevItems) => [...prevItems, ...response.data]);
                setHasMore(response.data.length === 10);
                setPage((prevPage) => prevPage + 1);
            } catch (error) {
                console.error('Error fetching items:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchItems();
    }, []);
    const fetchItems = async () => {
        setLoading(true);
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL + '/updates/items', { page, limit: 10 }, { withCredentials: true });
            setData((prevItems) => [...prevItems, ...response.data]);
            setHasMore(response.data.length === 10); // If we get less than 20 items, no more data
            setPage((prevPage) => prevPage + 1);

        } catch (error) {
            console.error('Error fetching items:', error);
        } finally {
            setLoading(false);
        }
    };
    const isOlderThan5Days = (dateString) => {
        const givenDate = new Date(dateString.replace(" ", "T")); // Convert to ISO format
        const currentDate = new Date();
        const fiveDaysAgo = new Date(currentDate);
        fiveDaysAgo.setDate(currentDate.getDate() - 5); // Subtract 5 days from the current date
        return givenDate < fiveDaysAgo;
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };
    return (
        <div className="mt-3 p-2 rounded-lg bg-slate-50 w-full">
            <span className="text-cyan-950 text-gray-700 text-sm  px-2 py-1 rounded-lg bg-slate-100 font-semibold flex items-center gap-2">
                <svg className='h-2 animate-ping' viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#000000" d="M8 3a5 5 0 100 10A5 5 0 008 3z"></path></g></svg>
                Updates
            </span>
            {data.length === 0 && (<><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div><div className="bg-white h-28 rounded-xl shadow mt-2 overflow-hidden relative"><div className="skeleton">
            </div></div></>)}
            {data.map((items, index) => (<div key={index} className="bg-white rounded-xl shadow p-2 mt-2">
                <a target="_blank" href={items.url} class="flex items-center">
                <div className="max-w-3xl rounded-md items-center flex">
                    <div className='flex items-center rounded-lg'>
                        <img className='h-10 w-16  mx-auto items-center opacity-60' src={'./img/navicons/' + items.type + ".svg"} />
                    </div>
                    <div className='pl-3 w-full'>
                        <div className='flex items-center'>
                            <h2 className="text-xs rounded-sm py-1 font-semibold text-gray-600">{type[items.type]}</h2>
                            {(items.date && (!isOlderThan5Days(items.date)) && (<span class="ml-2 inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 gap-2 items-center"><svg className='h-2 animate-ping' viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#000000" d="M8 3a5 5 0 100 10A5 5 0 008 3z"></path></g></svg>New</span>))}
                        </div>
                        <p className="text-sm font-semibold text-gray-800 overflow-hidden text-ellipsis">{items.name}</p>
                        <p class="text-gray-600 whitespace-no-wrap items-center">
                            <span className='text-xs'>{subCode[items.branch]}</span>
                        </p>
                        <p class="flex gap-1 text-slate-400 whitespace-no-wrap md:hidden items-center">
                            <span className='text-xs'>{formatDate(items.date)}</span>{items.sem != "all" && (<div className='flex gap-1 items-center'>•<p class="text-xs text-gray-500 whitespace-no-wrap">{semester[items.sem]}</p></div>)}
                        </p>
                    </div>
                </div>
                </a>
            </div>))}
            <div className="flex justify-center bg-white h-10 rounded-xl shadow mt-2 overflow-hidden">
                {!hasMore ? (<tr>
                    <td className='' colSpan={4}><><div class="h-10 flex items-center justify-center font-semibold text-xs"><div class="text-center">No more data</div>
                    </div></></td>
                </tr>):(
                    <button onClick={fetchItems} className='flex text-gray-500 items-center h-10 text-sm font-semibold gap-1'>
                    {loading ? (<>Loading...
                <div class="my-4 opacity-50 w-3 h-3 rounded-full animate-spin border-2 border-solid border-black border-t-transparent"></div></>)
                     :(<>Load More
                    <svg className='h-4 opacity-50' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></>)}
                </button>
                )
                }
            </div>
        </div>
    )
}
